import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { forwardRef, useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './48404219cb10939c86e5daacfa7d535fffaba81d8e00b9fd9aab9f417871c5f2.cfe-internal.js';
import '../../icons/index.es.js';
import '../Tooltip/ca664ad530b3b769c7b76cb94c664b585fc864e665376d1d61d1c56f079a099a.cfe-internal.js';
import { useToolbarContext, ToolbarProvider } from './a160cf879b7cab120bf814e64f156f70cee237e5ec6d1ada4eef9b879e36d9b6.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';
import Tooltip from '../Tooltip/303de8f785b9987afea88aa6b28176d2cc278b105d33ed5d93d1cf139ee9589d.cfe-internal.js';
import ChevronRightIcon from '../../icons/components/88a8116bd7f81fb87e1ae07d2c7a465dd4392543779b5970a2459038f6173e7a.cfe-internal.js';
import ChevronLeftIcon from '../../icons/components/4be65fa2c37c7c5ad2b1119dd9a3ebbad592dd6c1add59bde867d96dd5145c7a.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useIsHovered from '../../hooks/useIsHovered/83386cd5f16e29ff835560c8cdf55af8cde239328d4c1b8a04d10aa595f9462c.cfe-internal.js';
import { getIsKeyboardUser } from '../../utils/keyboardUser/20c2377f70ef9a94b4447542a95151abfb742a2428688e09defd93848a4c3b29.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';

var _excluded = ["isCollapsed", "className", "selectedTabPanelId", "isContainerHovered"],
  _excluded2 = ["isCollapsible", "defaultIsCollapsed", "isCollapsed", "onIsCollapsedChange", "children", "className"];
var ExpandCollapseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCollapsed = _ref.isCollapsed,
    className = _ref.className,
    selectedTabPanelId = _ref.selectedTabPanelId,
    isContainerHovered = _ref.isContainerHovered,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var showPanelLabel = translate('showPanel');
  var hidePanelLabel = translate('hidePanel');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTooltipVisible = _useState2[0],
    setIsTooltipVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHiddenByEscape = _useState4[0],
    setIsHiddenByEscape = _useState4[1];
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape' && !isCollapsed) {
      setIsHiddenByEscape(true);
    }
  };
  useEffect(function () {
    setIsHiddenByEscape(false);
  }, [isContainerHovered]);
  useEventListener(document, 'keydown', handleKeyDown);
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    content: isCollapsed ? showPanelLabel : hidePanelLabel,
    delayMs: 500,
    placement: "right",
    onShowChange: setIsTooltipVisible,
    show: isTooltipVisible && !isHiddenByEscape
  }, /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    type: "button",
    "aria-label": isCollapsed ? showPanelLabel : hidePanelLabel,
    className: classNames(styles.toolbarPanelExpandCollapseButton, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.toolbarPanelExpandCollapseButtonDefaultShown, isCollapsed), styles.toolbarPanelExpandCollapseButtonDefaultHidden, !isCollapsed), styles.overrideShow, isTooltipVisible), styles.overrideHide, isHiddenByEscape)),
    "aria-controls": selectedTabPanelId,
    "aria-expanded": !isCollapsed,
    ref: ref,
    onBlur: function onBlur() {
      return setIsHiddenByEscape(false);
    }
  }), /*#__PURE__*/React__default.createElement("span", null, isCollapsed ? /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
    size: "small",
    "aria-hidden": "true"
  }) : /*#__PURE__*/React__default.createElement(ChevronLeftIcon, {
    size: "small",
    "aria-hidden": "true"
  }))));
});
var ToolbarPanels = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _props$id, _React$Children$toArr, _context, _context2;
  var _ref2$isCollapsible = _ref2.isCollapsible,
    isCollapsible = _ref2$isCollapsible === void 0 ? true : _ref2$isCollapsible,
    _ref2$defaultIsCollap = _ref2.defaultIsCollapsed,
    defaultIsCollapsed = _ref2$defaultIsCollap === void 0 ? false : _ref2$defaultIsCollap,
    externalIsCollapsed = _ref2.isCollapsed,
    onIsCollapsedChange = _ref2.onIsCollapsedChange,
    children = _ref2.children,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var expandCollapseButtonRef = useRef(null);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isExpandCollapseButtonKeyboardFocused = _useState6[0],
    setIsExpandCollapseButtonKeyboardFocused = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    wasExpandCollapseButtonClicked = _useState8[0],
    setWasExpandCollapseButtonClicked = _useState8[1];
  var _useControllableState = useControllableState(isCollapsible && defaultIsCollapsed, isCollapsible ? onIsCollapsedChange : undefined, isCollapsible && externalIsCollapsed),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    isCollapsed = _useControllableState2[0],
    setIsCollapsed = _useControllableState2[1];
  var _useToolbarContext = useToolbarContext(),
    selectedIndex = _useToolbarContext.selectedIndex,
    toolbarId = _useToolbarContext.id,
    rootDataTestId = _useToolbarContext.rootDataTestId;
  var _useIsHovered = useIsHovered(),
    _useIsHovered2 = _slicedToArray(_useIsHovered, 2),
    isToolbarPanelsContainerHoveredRef = _useIsHovered2[0],
    isToolbarPanelsContainerHovered = _useIsHovered2[1];
  useEffect(function () {
    /*
     * The expand/collapse button is re-rendered when the `isCollapsed` value changes.
     * The re-render hides the tooltip.
     * This needs to happen because the `Tooltip`'s `mouseleave` event does not get triggered when the button element moves (this is expected behavior).
     * Since the button is re-rendered, if there is keyboard focus, we need to programmatically re-focus the button because React doesn't know that it's the same button.
     */
    if (isExpandCollapseButtonKeyboardFocused) {
      var _expandCollapseButton;
      (_expandCollapseButton = expandCollapseButtonRef.current) === null || _expandCollapseButton === void 0 || _expandCollapseButton.focus();
    }
  }, [isCollapsed, isExpandCollapseButtonKeyboardFocused]);
  useEffect(function () {
    /*
     * Similar to the above `useEffect`, the expand/collapse button is re-rendered when the `isCollapsed` value changes.
     * If the button is clicked, we need to programmatically re-focus the button.
     * This allows a screen reader user to click the expand/collapse button using their keyboard and have focus stay on the same button.
     */
    if (wasExpandCollapseButtonClicked) {
      var _expandCollapseButton2;
      (_expandCollapseButton2 = expandCollapseButtonRef.current) === null || _expandCollapseButton2 === void 0 || _expandCollapseButton2.focus();
      setWasExpandCollapseButtonClicked(false);
    }
  }, [wasExpandCollapseButtonClicked]);
  var onExpandCollapseButtonMouseDown = function onExpandCollapseButtonMouseDown() {
    setIsExpandCollapseButtonKeyboardFocused(false);
  };
  var onExpandCollapseButtonClick = function onExpandCollapseButtonClick() {
    setIsCollapsed(function (currentIsCollapsed) {
      return !currentIsCollapsed;
    });
    setWasExpandCollapseButtonClicked(true);
  };
  var onExpandCollapseButtonFocus = function onExpandCollapseButtonFocus() {
    if (getIsKeyboardUser()) {
      setIsExpandCollapseButtonKeyboardFocused(true);
    }
  };
  var onExpandCollapseButtonBlur = function onExpandCollapseButtonBlur() {
    setIsExpandCollapseButtonKeyboardFocused(false);
  };
  var selectedTabPanelId = (_props$id = (_React$Children$toArr = React__default.Children.toArray(children)) === null || _React$Children$toArr === void 0 || (_React$Children$toArr = _React$Children$toArr[Number(selectedIndex)]) === null || _React$Children$toArr === void 0 || (_React$Children$toArr = _React$Children$toArr.props) === null || _React$Children$toArr === void 0 ? void 0 : _React$Children$toArr.id) !== null && _props$id !== void 0 ? _props$id : _concatInstanceProperty(_context = "toolbar-".concat(toolbarId, "-panel-")).call(_context, selectedIndex);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: mergeRefs(ref, isToolbarPanelsContainerHoveredRef),
    className: classNames(className, styles.toolbarPanels, _defineProperty({}, styles.toolbarPanelsCollapsed, isCollapsed))
  }), isCollapsible ? /*#__PURE__*/React__default.createElement(ExpandCollapseButton, {
    key: String(isCollapsed),
    isCollapsed: isCollapsed,
    selectedTabPanelId: selectedTabPanelId,
    onMouseDown: onExpandCollapseButtonMouseDown,
    onClick: onExpandCollapseButtonClick,
    onFocus: onExpandCollapseButtonFocus,
    onBlur: onExpandCollapseButtonBlur,
    isContainerHovered: isToolbarPanelsContainerHovered,
    "data-testid": getSubDataTestId(rootDataTestId, 'panels-expand-collapse-button'),
    ref: expandCollapseButtonRef
  }) : null, _mapInstanceProperty(_context2 = React__default.Children).call(_context2, children, function (child, index) {
    return /*#__PURE__*/React__default.createElement(ToolbarProvider, {
      value: {
        selectedIndex: selectedIndex,
        index: index,
        toolbarId: toolbarId,
        isCollapsed: isCollapsed,
        rootDataTestId: rootDataTestId
      }
    }, child);
  }));
});

export { ToolbarPanels as default };
